export const ModalSubscribeTableConfig = [
  {
    title: "구독 ID",
    dataIndex: "id"
  },
  {
    title: "구독",
    dataIndex: "type"
  },
  {
    title: "개월 수",
    dataIndex: "period"
  },
  {
    title: "선택",
    dataIndex: "",
    scopedSlots: {
      customRender: "choice"
    }
  }
];
